export default __webpack_public_path__ + "static/media/17-Brid Spa-111.25bb9252.jpg";